import React, { Fragment } from 'react';
import { Box } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import { colorPalette } from 'styles/partials/colors';
import { AzulSkeleton } from '@the-ksquare-group/azul-ds';

interface ImageDummyProps {
  isLoading?: boolean;
  skeletonWidth?: number;
  skeletonHeight?: number;
}

const ImageDummy = ({ isLoading, skeletonWidth, skeletonHeight }: ImageDummyProps) => {
  return (
    <Fragment>
      {isLoading ? (
        <AzulSkeleton width={skeletonWidth || 283} height={skeletonHeight || 148} variant='rounded' />
      ) : (
        <Box
          alignItems='center'
          bgcolor={colorPalette.imageDummyContainer}
          borderRadius='8px'
          display='flex'
          height='max-content'
          justifyContent='center'
        >
          <ImageIcon sx={{ color: colorPalette.imageDummyIcon, fontSize: '36px', margin: '3.5rem' }} />
        </Box>
      )}
    </Fragment>
  );
};

export default ImageDummy;
